import './style.css'

type TSectionContainerProps = {
  children: React.ReactNode
}

export const SectionContainer = ({
    children
}: TSectionContainerProps) => {
    return (
        <div className="section-container">
            {children}
        </div>
    );
};

export default SectionContainer